<template>
    <div class="MainSearch">
    <div class="Form">
        <div class="FormRow">
            <div class="FormBoxWide FormInputText">
                <div class="Field"><input type="text" v-model="this.searchText" @keypress.enter="this.doSearch()" :placeholder="this.risorse['Ricerca'] + '...'" /></div>
            </div>
            <div class="FormBoxWide FormSelect">
                <div class="Field">
                    <div class="WizardSelect">{{this.searchCatalogDescr}}</div>
                    <table class="WizardOption" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td valign="middle" @click="setCatalogo('', this.risorse['TuttiCataloghi'])">{{this.risorse['TuttiCataloghi']}}</td>
                            </tr>
                            <tr v-for="catalog in this.$store.getters.getCatalogs" :key="catalog?.IdCatalogo">                                
                                <td valign="middle" @click="setCatalogo(catalog?.IdCatalogo, catalog?.Descrizione)">{{catalog?.Descrizione}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="FormBoxWide FormInputButton">
                <div class="Field Button CustomColor" @click="doSearch()">
                    <span><img src="/images/SearchIcon.png" srcset="/images/SearchIconRetina.png 2x" alt="" /></span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import {risorseMixin} from "@/mixin.js";

export default {
    name: "Quicksearch",
    data(){
        return  {
            searchCatalog : "",
            searchCatalogDescr :  "",
            searchText:""
        }
    }, 
    mixins:[risorseMixin],
    methods:{
        setCatalogo(catalog, catalogDescr){        
            $(".WizardSelect").toggleClass('Open').toggleClass('Close');
            $(".WizardSelect").parent().find(".WizardOption").slideToggle('fast');        
            this.searchCatalog  = catalog;
            this.searchCatalogDescr = catalogDescr;
        },
        doSearch(){               
            this.$router.push({name: "SearchResults", query:{searchCatalog : this.searchCatalog , searchText : this.searchText, searchCatalogDescr : this.searchCatalogDescr}});
        }
    },
    mounted(){

        this.searchCatalogDescr = this.risorse["TuttiCataloghi"];

        $(document).ready(function() {
            $(".WizardOption").hide();
            $(".WizardSelect").addClass('Open');
            $(".WizardSelect").click(function(){
                $(this).parent().find(".WizardOption").slideToggle('fast');
                $(this).toggleClass('Open').toggleClass('Close');
            });            
        });
    }
}
</script>